<template>
  <div>
    <div id="recaptcha"></div>
    <TheHeader/>
    <div class="c-app flex-row align-items-center bg-overlay">    
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="5">
          <CCardGroup >
            <CCard class="pl-4 pr-4" style="background-color:rgba(0,0,0,.85); border-radius: 20px;">
              <CCardBody >
                <CForm v-if="loginType=='email'">
                  <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:15px;">Login</h1>
                  <div class="form-group">
                    <input
                    placeholder="Username"
                    autocomplete="username email"
                    v-model="email"
                    class="form-control material-input "
                    />
                    <small v-if="errors.email" class="form-text text-muted" style="color:red">
                      <p class="text-danger p-0 m-0">{{errors.email}}</p>
                    </small>
                  </div>
                  <div class="form-group">
                    <input
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="password"
                    class="form-control material-input "
                    />
                    <small v-if="errors.password" class="form-text text-muted" style="color:red">
                      <p class="text-danger p-0 m-0">{{errors.password}}</p>
                    </small>
                  </div>
                  <CRow>
                    <CCol col="12" class="text-left">
                      <button type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="onSignIn">Login</button>
                      <!-- <CButton style="background-color:#ee8174;color:white;"  @click="onSignIn">Login
                        <b-icon v-show="loading" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
                      </CButton> -->
                    </CCol>
                    <!-- <CCol col="6" class="text-right">
                      <b-button variant="link" style=";color:#ee8174;" to="/register" >Register Now</b-button>
                    </CCol> -->
                  </CRow>
                </CForm>
                <CForm v-if="loginType=='mobile'">
                  <h1 style="text-align:center; color:white; font-size:28px; padding-bottom:15px;">Login</h1>
                  <div  v-if="!otpSent">
                    <!-- <input
                    placeholder="Mobile"
                    v-model="mobile"
                    class="form-control material-input "
                    /> -->
                    <vue-tel-input v-model="mobile"  
                        mode="international"
                        input-classes="aumhum-tel-input" 
                        wrapper-classes ="aumhum-tel-input-wrapper"
                        style="margin-bottom: 1rem; border: 0px; border-bottom: 1px solid #fff;  border-radius: 0; outline: 0;-webkit-box-shadow: none; box-shadow: none;"  ></vue-tel-input>
                    <small v-if="errors.mobile" class="form-text text-muted" style="color:red">
                      <p class="text-danger p-0 m-0">{{errors.mobile}}</p>
                    </small>
                  </div>
                  <div class="form-group" v-if="!isNewUser&&otpSent">
                    <input
                    placeholder="Verification Code"
                    v-model="verificationCode"
                    class="form-control material-input"
                    />
                    <small v-if="errors.verificationCode" class="form-text text-muted" style="color:red">
                      <p class="text-danger p-0 m-0">{{errors.verificationCode}}</p>
                    </small>
                  </div>
                  <div class="form-group" v-if="isNewUser">
                    <input
                    placeholder="Name"
                    v-model="name"
                    class="form-control material-input"
                    />
                    <small v-if="errors.name" class="form-text text-muted" style="color:red">
                      <p class="text-danger p-0 m-0">{{errors.name}}</p>
                    </small>
                  </div>
                  <CRow>
                    <CCol col="12" class="text-left">
                      <button v-if="!otpSent" type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="sendOtpToMobileNumber">Tap to proceed</button>
                      <button v-if="!isNewUser&&otpSent" type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="onMobileLoginIn">Verify</button>
                       <button v-if="isNewUser" type="button" style="width:100%;border-radius:30px" class="btn btn-lg btn-outline-aumhum" @click="onMobileSignUp">Tap to proceed</button>
                      <!-- <CButton style="background-color:#ee8174;color:white;"  @click="onSignIn">Login
                        <b-icon v-show="loading" icon="arrow-clockwise" animation="spin" font-scale="1"></b-icon>
                      </CButton> -->
                    </CCol>
                    <!-- <CCol col="6" class="text-right">
                      <b-button variant="link" style=";color:#ee8174;" to="/register" >Register Now</b-button>
                    </CCol> -->
                  </CRow>
                </CForm>
              </CCardBody>
                <CCardFooter >
                    <!-- <CRow >
                        <div style="width:100%; text-align:center;">
                            <span style="color:#C1C1C1;  border-bottom: solid; border-bottom-color: #C1C1C1">Forgot Password?</span>
                        </div>
                    </CRow> -->
                  <CRow class="pb-2" v-if="loginType=='email'">
                    <p style="width:100%; color:#C1C1C1; text-align:center"><b-button variant="link" style=" color: #C1C1C1; padding:0" to="/forgot-password" >Forgot Password?</b-button></p>
                  </CRow>
                   <CRow >
                        <p style="width:100%; color:#C1C1C1; text-align:center">OR CONTINUE WITH</p>
                    </CRow>
                    <CRow >
                      <CCol col="12" class="text-center">
                         <img src="/img/Facebook-white-icon@2x.png"  style="border: 1px solid #c1c1c1; border-radius:23px;
                          padding: 10px; width: 45px; margin:10px; cursor:pointer; " @click="onFacebookSignIn" />
                        <!-- <b-button   variant="primary" @click="onFacebookSignIn" >Facebook</b-button> -->
                        <img src="/img/Google-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                          padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onGoogleSignIn" />
                          <img src="/img/Apple-white-icon@2x.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                          padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="onAppleSignIn" />
                          <span v-if="isMobileLoginEnabled">
                            <img v-if="loginType=='email'" src="/img/mobile-alt-solid.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                            padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="loginType='mobile'" />
                            <img v-if="loginType=='mobile'" src="/img/envelope-solid.png" style="border: 1px solid #c1c1c1; border-radius:23px;
                            padding: 10px; width: 45px; margin:10px; cursor:pointer;" @click="loginType='email'" />
                          </span> 
                      </CCol>
                      <!-- <CCol col="6" class="text-right">
                        <b-button variant="link" style=";color:#ee8174;" to="/register" >Register Now</b-button>
                      </CCol> -->
                    </CRow>
                      <CRow class="pt-2">
                              <p style="width:100%; color:#C1C1C1; text-align:center">Don't have an account? <b-button variant="link" style=" color: #F3756B; padding:0" to="/register" >Sign up here</b-button></p>
                      </CRow>
                      <CRow v-show="error" class="pt-2">
                        <CCol col="12" class="text-center">
                          <b-alert show variant="danger" dismissible @dismissed="error=''"><strong>Error!</strong> <span v-html="error"></span></b-alert>
                        </CCol>
                      </CRow>
                  </CCardFooter>

              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
     
    <TheFooter/>
    <CModal
      title="Link accounts"
      color="dark"
      closeOnBackdrop:="false"
      :show.sync="linkCredentialSocialModal"
    >
      An account with email <b>{{linkCredentialEmail}}</b> already exists using {{linkCredentialProvider}} login. 
      Please Sign in using {{linkCredentialProvider}} to link both the account and proceed.
      
      <template v-slot:footer>
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="linkCredentialSocialModal = false">Cancel</button>
        <button type="button" class="btn btn-dark" @click="linkCredentialUsingProvider">Ok</button>
      </template>
    </CModal>

    <CModal
      title="Link accounts"
      color="dark"
      closeOnBackdrop:="false"
      :show.sync="linkCredentialPasswordModal"
    >
      An account with email <b>{{linkCredentialEmail}}</b> already exists. 
      Please provide your password to login and link both the account. 

      <div class="form-group" style="margin-top: 16px;">
        <input class="form-control" type="password" placeholder="Enter your password" autocomplete="off" v-model="password">
      </div>
      
      <template v-slot:footer>
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="linkCredentialPasswordModal = false">Cancel</button>
        <button type="button" class="btn btn-dark" @click="linkCredentialUsingPassword">Login</button>
      </template>
    </CModal>

 <Loading :active.sync="isLoading" 
        color="#F3756B"
        background-color="#000"
        :opacity="0.9"
        loader="spinner"
        :is-full-page="true">
    </Loading>
  </div>
</template>

<script>
//import firebase from 'firebase'
import firebase from 'firebase'
import axios from 'axios';
import * as location from '@/utils/location.js'
import TheHeader from '@/components/layout/TheDarkHeader'
import TheFooter from '@/components/layout/TheDarkFooter'
import Loading from 'vue-loading-overlay';
import { VueTelInput } from 'vue-tel-input';
import '@/assets/app.css'

export default {
  name: 'Login',
  components: {
   // TheSidebar,
    TheHeader,
    TheFooter,
    Loading,
    VueTelInput,
  },
  data () {
    return {
        email: '',
        password: '',
        error:'',
        errors:{},

        loginType:'email',
        mobile:null,
        otpSent:false,
        verificationCode:null,
        recaptchaVerifier :null,
        confirmationResult:null,
       
        linkCredentialSocialModal: false,
        linkCredentialPasswordModal: false,
        isLoading:false,

        location:null,
        isMobileLoginEnabled:true,
        isNewUser:false,
        accessToken:'',
        name:'',
    }
  },
  computed : {
    linkCredentialProvider() {
      return this.$store.state.auth.linkCredential ? this.$store.state.auth.linkCredential.provider : '';
    },
    linkCredentialEmail() {
      return this.$store.state.auth.linkCredential ? this.$store.state.auth.linkCredential.email : '';
    },
    setup(){
      return this.$store.state.user.setup ;
    },
    
  },
  created(){
      this.getCurrentLocation();
  },
  watch :{

    setup(val){
      console.log(val)
      this.checkMobileLoginEnabled();
    },
    location(val){
       console.log(val)
       this.checkMobileLoginEnabled();
    }

  },
  methods: {
      checkMobileLoginEnabled(){
        if(this.setup!=null&&this.location!=null&&this.setup.metaDefaults.mobile_login&&this.setup.metaDefaults.mobile_login.countries.length){
          var countryCode = this.location.countryCode.toLowerCase();
          if(this.setup.metaDefaults.mobile_login.countries.includes(countryCode)){
            this.isMobileLoginEnabled = true;
            this.loginType='mobile'
          }else{
            this.isMobileLoginEnabled = false;
            this.loginType='email'
          }
        }
      },
      getCurrentLocation(){
        location.getCurrentLocation()
            .then((data) => {
                this.location = data;
                console.log('Location: ', data);
            })
      },

      sendOtpToMobileNumber(){
        var self = this;
        self.isLoading = true;
        self.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha', {
          'size': 'invisible',
          'callback': () => {
          },
          'expired-callback': () => {
          }
        })
        self.recaptchaVerifier.render()
        firebase.auth().signInWithPhoneNumber(self.mobile, self.recaptchaVerifier)
            .then(function (confirmationResult) {
              self.isLoading = false;
              console.log(confirmationResult)
              self.otpSent = true;
              self.confirmationResult = confirmationResult;
            }).catch(function (error) {
              self.isLoading = false;
              console.log(error)
               this.error = error.message;
            });
      },
      onMobileLoginIn(){
          var self = this;
          self.isLoading = true;
          var credential = firebase.auth.PhoneAuthProvider.credential(self.confirmationResult.verificationId, self.verificationCode);
            firebase.auth().signInWithCredential(credential)
            .then(function(response){
                console.log(response);
                if(response.user.displayName==''||response.user.displayName==null){
                  self.isNewUser = true;
                  self.accessToken = response.user.ya;
                  self.isLoading = false;
                }else{
                   self.$store.dispatch('auth/refreshLoginData')
                        .then(()=>{
                              self.isLoading = false;
                              self.$router.replace('/web/profile');
                         });
                }
            })
            .catch(function(){
                 self.isLoading = false;
                 self.errors.verificationCode='Incorrect Verification Code'
            });
      },
      onMobileSignUp(){
          var self = this;
          self.errors={};
          if(self.name==''){
            self.errors.name='Mandatory';
          }
          if(Object.keys(self.errors).length>0){
            return ;
          }
          self.isLoading = true;
            var body = {};
            body.location = self.location;
            body.name = self.name;
            body.mobile = self.mobile;
            body.accessToken = self.accessToken;
            console.log(body)
            var urlTemp = process.env.VUE_APP_API_BASE_URL + '/api/user/firebase/mobile/login';
            axios.post(urlTemp,body)
                .then(()=>{
                  self.$store.dispatch('auth/refreshLoginData')
                  .then(()=>{
                        self.isLoading = false;
                        self.$router.replace('/web/profile');
                    });
                });
          
      },
      onSignIn() {
        this.isLoading = true;
        
        var self = this;
        self.errors={};
        if(self.email==''){
          self.errors.email='Incorrect email address'
        }
        if(self.password==''){
          self.errors.password='Mandatory';
        }
        if(Object.keys(self.errors).length>0){
          return ;
        }
        // login to server if valid user then login to firebase to get auth session 
        var data = {username:this.email,password:this.password}
        this.$store.dispatch('auth/signInWithUsernamePassword',data)
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch((e) => {
            this.isLoading = false;
            if( e.response ){
                console.log(e.response.data); // => the response payload 
                this.error = e.response.data.message;
            }else{
              console.log(e);
              this.error = 'NETWORK ISSUE.';
            }
           
            
        });

      },
      onFacebookSignIn(){
        this.isLoading = true;
        this.$store.dispatch('auth/signInWithFacebook')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            this.isLoading = false;
            console.log(err);
            if(err.err_code === 'auth/account-exists-with-different-credential') {
              if(err.method === 'password') {
                this.linkCredentialPasswordModal = true;
              } else {
                this.linkCredentialSocialModal = true;
              }
            } else {
              this.error = err.error.message;
            }
        });
      },
      onGoogleSignIn(){
        this.isLoading = true;
        this.$store.dispatch('auth/signInWithGoogle')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            this.isLoading = false;
            console.log(err);
            if(err.err_code === 'auth/account-exists-with-different-credential') {
              if(err.method === 'password') {
                this.linkCredentialPasswordModal = true;
              } else {
                this.linkCredentialSocialModal = true;
              }
            } else {
              this.error = err.error.message;
            }
        });
      },
      onAppleSignIn(){
        this.isLoading = true;
        this.$store.dispatch('auth/signInWithApple')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            this.isLoading = false;
            console.log(err);
            if(err.err_code === 'auth/account-exists-with-different-credential') {
              if(err.method === 'password') {
                this.linkCredentialPasswordModal = true;
              } else {
                this.linkCredentialSocialModal = true;
              }
            } else {
              this.error = err.error.message;
            }
        });
      },
      linkCredentialUsingProvider(){
        this.linkCredentialSocialModal = false;
        this.isLoading = true;
         
        this.$store.dispatch('auth/linkCredentialUsingProvider')
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            this.isLoading = false;
            console.log(err);
            this.error = err.error.message;
        });
      },
      linkCredentialUsingPassword(){
        this.linkCredentialPasswordModal = false;
        this.isLoading = true;
         
        this.$store.dispatch('auth/linkCredentialUsingPassword', [this.password])
        .then(()=>{
            this.$router.replace('/web/profile');
        })
        .catch(err => {
            this.isLoading = false;
            console.log(err);
            this.error = err.error.message;
        });
      }
       
    }

}
</script>
<style scoped>

     
</style>

